
/* @ngInject */

export default function SubscriptionContentSetsModalCtrl ($uibModalInstance, item, checkIntersection) {
  const vm = this
  vm.item = item
  vm.openFooter = window.innerHeight > 750
  vm.contentTypes = {
    channel: 'Channel',
    tv_show: 'TV Show',
    live_event: 'Live Event',
    vod: 'VOD',
    SEASON: 'Season',
    EPISODE: 'Episode'
  }

  vm.access = {
    channel: 'editChannel',
    tv_show: 'editVodSeries',
    live_event: 'editLiveEvent',
    vod: 'editVod'
  }

  vm.type = vm.contentTypes[item.$setType]

  vm.checkIntersection = function () {
    checkIntersection()
      .then(() => {
        if (!vm.item.conflicts?.length) {
          $uibModalInstance.dismiss()
        }
      })
  }

  vm.closeConflicts = $uibModalInstance.dismiss
}
